import { MediaContentShowcaseItem } from 'onnit-ui/lib/module/MediaContentShowcase';

const ingredientsFocusBend: MediaContentShowcaseItem[] = [
    {
        image: `alpha-gpc.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Alpha-GPC',
        summary: 'A compound which acts as a precursor to acetylcholine.',
        detail: 'Aids its production in the body.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `huperzia-serrata.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Huperzia serrata',
        summary: 'This Clubmoss contains Huperzine A.',
        detail: 'Shown to help stop the breakdown of acetylcholine.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `bacopa.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Bacopa',
        summary: 'A perennial herb.',
        detail: 'Shown to help nerve signal reception by promoting the growth of the parts of nerve cells that receive messages from other nerves.<span class="oui-sup">&dagger;</span>',
    }
];

export default ingredientsFocusBend;
